import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import pt from 'vuetify/es5/locale/pt';
import es from 'vuetify/es5/locale/es';
import en from 'vuetify/es5/locale/en';

import Cookies from 'js-cookie';

Vue.use(Vuetify);

const locale = Cookies.get('locale') || 'pt';

export default new Vuetify({
  lang: {
    locales: { pt, es, en },
    current: locale
  }
});
